import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { API_URL } from '../../../settings/local_settings';
import { APIClient } from '../../../utils/APIClient';
import { Spinner } from '../../Spinner';
import { withTranslation } from 'react-i18next';

class CancelSubscriptionModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            sending: false,
            sent: false,
            reason: '',
            comments: ''
        };
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
            sending: false,
            sent: false,
            reason: '',
            comments: ''
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ sending: true });

        new APIClient(API_URL + 'agency/subscription/cancel/')
            .call('POST', {
                reason: this.state.reason,
                comments: this.state.comments
            })
            .then((data) => {
                if (data.status === 'OK') {
                    this.setState({ sending: false, sent: true });
                } else {
                    this.setState({ sending: false });
                    alert(data.error_message || 'Error');
                }
            });
    }

    render() {
        const { t } = this.props;
        const { isOpen, sending, sent } = this.state;

        return (
            <>
                <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={this.toggle}
                >
                    {t('agency_subscription.cancel_subscription')}
                </button>
                <Modal isOpen={isOpen} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        {t('agency_subscription.cancel_subscription_title')}
                    </ModalHeader>
                    {sent ? (
                        <>
                            <ModalBody>
                                <div style={{ textAlign: 'center', padding: '1rem' }}>
                                    <div style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#198754' }}>&#10003;</div>
                                    <p>{t('agency_subscription.cancellation_sent')}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>{t('agency_subscription.close')}</Button>
                            </ModalFooter>
                        </>
                    ) : (
                        <form onSubmit={this.handleSubmit}>
                            <ModalBody>
                                <p style={{ color: '#dc3545', fontWeight: 600 }}>
                                    {t('agency_subscription.cancel_warning')}
                                </p>
                                <div className="form-row" style={{ marginBottom: '1rem' }}>
                                    <label>{t('agency_subscription.cancel_reason')}</label>
                                    <select
                                        className="form-control"
                                        value={this.state.reason}
                                        onChange={(e) => this.setState({ reason: e.target.value })}
                                        required
                                    >
                                        <option value="">{t('agency_subscription.select_option')}</option>
                                        <option value="too_expensive">{t('agency_subscription.reason_too_expensive')}</option>
                                        <option value="not_using">{t('agency_subscription.reason_not_using')}</option>
                                        <option value="missing_features">{t('agency_subscription.reason_missing_features')}</option>
                                        <option value="switching_tool">{t('agency_subscription.reason_switching_tool')}</option>
                                        <option value="closing_agency">{t('agency_subscription.reason_closing_agency')}</option>
                                        <option value="other">{t('agency_subscription.other')}</option>
                                    </select>
                                </div>
                                <div className="form-row">
                                    <label>{t('agency_subscription.comments')}</label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={this.state.comments}
                                        onChange={(e) => this.setState({ comments: e.target.value })}
                                        placeholder={t('agency_subscription.cancel_comments_placeholder')}
                                    />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>{t('agency_subscription.keep_subscription')}</Button>
                                {sending
                                    ? <Spinner color="positive small" />
                                    : <Button color="danger" type="submit">{t('agency_subscription.confirm_cancel')}</Button>
                                }
                            </ModalFooter>
                        </form>
                    )}
                </Modal>
            </>
        );
    }
}

export default withTranslation()(CancelSubscriptionModal);
